import React from 'react';
import PropTypes from 'prop-types';
/* Components */
import AuthWrapper from '../../components/auth-wrapper/auth-wrapper';
import Input from '../../components/input/input';
import Validation from '../../components/validation/validation';
import PasswordStrength from '../../components/password-strength/password-strength';

class ResetPasswordPage extends React.PureComponent {
    state = {
        password: '',
        repeatPassword: ''
    };

    setValue = prop => value => {
        this.setState({
            [prop]: value
        });
    };

    render() {
        const { useCreatePasswordForm, token, returnUrl, username } = this.props.model;
        return (
            <AuthWrapper heading={useCreatePasswordForm ? 'Create Password' : 'Reset Password'}>
                <Validation.Form
                    className="sten-content__body"
                    method="post"
                    name="ResetPassword"
                    action="ResetPassword"
                >
                    <input type="hidden" name="Token" value={token || ''} />
                    <input type="hidden" name="ReturnUrl" value={returnUrl || ''} />
                    <input type="hidden" name="Username" value={username || ''} />
                    <input type="hidden" name="UseCreatePasswordForm" value={useCreatePasswordForm || false} />
                    {useCreatePasswordForm
                        ? (
                            <section className="sten-content__section">
                                <p>Please create your password to complete account creation process</p>
                            </section>
                        ) : (
                            <section className="sten-content__section"><p>Enter your new password below.</p></section>
                        )}
                    <section className="sten-content__section">
                        <Validation.Wrapper
                            validations={{
                                required: true,
                                minLength: 8,
                                maxLength: 30,
                                containsCharTypes: {
                                    types: ['lowercase', 'uppercase', 'digits', 'special'],
                                    length: 3
                                },
                                strength: {
                                    totalScore: 60,
                                    diffChars: 5
                                }
                            }}
                        >
                            <Input
                                autoFocus
                                name="NewPassword"
                                className="sten-input--sm"
                                type="password"
                                id="userPassword"
                                placeholder="Password"
                                value={this.state.password}
                                onChange={this.setValue('password')}
                                showKeyboard
                            />
                        </Validation.Wrapper>
                        <PasswordStrength value={this.state.password} />
                    </section>
                    <section className="sten-content__section">
                        <Validation.Wrapper
                            validations={{
                                required: true,
                                equalAs: { prop: 'NewPassword', label: 'Password' }
                            }}
                        >
                            <Input
                                name="RepeatPassword"
                                className="sten-input--sm"
                                type="password"
                                placeholder="Repeat Password"
                                value={this.state.repeatPassword}
                                onChange={this.setValue('repeatPassword')}
                                showKeyboard
                            />
                        </Validation.Wrapper>
                    </section>
                    <section className="sten-content__section">
                        <div className="sten-content__separator" />
                    </section>
                    <section className="sten-content__section">
                        <Validation.Button name="button" value="submit" className="btn btn--primary btn--sm col-24">
                            Submit
                        </Validation.Button>
                    </section>
                    <input name="__RequestVerificationToken" type="hidden" value={this.props.token} />
                </Validation.Form>
            </AuthWrapper>
        );
    }
}

ResetPasswordPage.propTypes = {
    token: PropTypes.string.isRequired,
    model: PropTypes.objectOf(PropTypes.any).isRequired
};

export default ResetPasswordPage;
